var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.954102H513V342.958H0V0.954102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 49.9121H513V98.8755H0V49.9121ZM0 245.766H513V294.729H0V245.766Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.954102H513V49.9175H0V0.954102Z",
    fill: "#057F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 98.8809H513V147.844H0V98.8809ZM0 196.809H513V245.772H0V196.809Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 294.735H513V342.957H0V294.735Z",
    fill: "#057F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.533 171.95L106.537 342.947H0V0.954102H106.537L277.533 171.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 171.951L85.501 342.95H106.529L277.529 171.951L106.529 0.951172H85.501L256.5 171.951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.666 118.42L115.95 159.312H158.951L124.166 184.587L137.451 225.481L102.666 200.207L67.8778 225.481L81.1657 184.587L46.3799 159.312H89.3787L102.666 118.42Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.212 175.296L104.585 163.029C104.585 163.029 102.027 139.028 101.872 138.215C100.697 132.023 95.2559 127.343 88.7232 127.343C81.3328 127.343 75.3401 133.334 75.3401 140.726C75.3401 141.951 75.5185 143.133 75.8271 144.261L66.1191 154.035H83.3818C83.3818 171.952 70.0117 171.952 70.0117 189.796L77.4282 207.639H122.037L129.474 189.796H129.47C130.195 188.129 130.662 186.362 130.853 184.554C137.263 181.96 139.212 175.296 139.212 175.296Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.954102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZw);
export default __webpack_public_path__ + "static/media/ZW.52afb442cc58d7bf3e92bb8cc0be81cf.svg";
export { ForwardRef as ReactComponent };